import script from "./LaudoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LaudoPage.vue?vue&type=script&setup=true&lang=js"

import "./LaudoPage.vue?vue&type=style&index=0&id=493b7172&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-493b7172"]])

export default __exports__